import Expander from '@tian-libs/expander'

export default defineNuxtPlugin(nuxtApp => {
    try{
        nuxtApp.vueApp.use(Expander)
    }catch(e){
        alert(e)
    }
})